import { TableCell, TableRow, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const HeadTableCell = styled(TableCell)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.2,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.default,
    position: 'sticky',
    top: 0,
    zIndex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:first-of-type': {
        paddingLeft: 24,
    },
    '&:last-of-type': {
        paddingRight: 24,
    },
}));

export const BodyTableCell = styled(HeadTableCell)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 500,
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    transition: 'background-color .2s ease',
    '&:nth-of-type(odd)': {
        backgroundColor: alpha(theme.palette.primary.main, 0.02),
    },
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.06),
    },
}));
